// extracted by mini-css-extract-plugin
module.exports = {"SendFeedback":"SendFeedback_SendFeedback__WoiOg"};